const uniqueArrayById = <T extends { id: string }>(array: T[]) => {
  const map = new Map(array.map((item) => [item.id, item]))
  return Array.from(map.values())
}

export default uniqueArrayById
